/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_Errors_HelpInputs */

const en_directory_mcp_errors_help = /** @type {(inputs: Directory_Mcp_Errors_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool failures mirror the REST envelope: read structuredContent.error.code, not the message.`)
};

const zh_directory_mcp_errors_help = /** @type {(inputs: Directory_Mcp_Errors_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具失败与 REST 信封一致：读取 structuredContent.error.code，不要依赖 message。`)
};

/**
* | output |
* | --- |
* | "Tool failures mirror the REST envelope: read structuredContent.error.code, not the message." |
*
* @param {Directory_Mcp_Errors_HelpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_errors_help = /** @type {((inputs?: Directory_Mcp_Errors_HelpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_Errors_HelpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_errors_help(inputs)
	return zh_directory_mcp_errors_help(inputs)
});
export { directory_mcp_errors_help as "directory.mcp.errors_help" }